import BaseRepository from '@/api/repositories/BaseRepository';

export default class PremiumCaseReferralRepository extends BaseRepository {
	getReferrals(month, year, filter) {
		return this.get('premium-case-referrals', { month: month, year: year, filter: filter});
	}
	setBilledReferrals(data) {
		return this.post('premium-case-referrals/set-to-billed', {}, data);
	}
}
